/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobEngineTestSub {
    getFixupPrototypeFunction() { return BackgroundJobEngineTestSub.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobEngineTestSub>): BackgroundJobEngineTestSub {
        let obj = Object.assign(new BackgroundJobEngineTestSub(), model);
        BackgroundJobEngineTestSub.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobEngineTestSub>): BackgroundJobEngineTestSub {
        if (!model) return null;
        return BackgroundJobEngineTestSub.newInstance(<BackgroundJobEngineTestSub> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobEngineTestSub) {
        if (!obj) return;

        models.BackgroundJobEngineTestSub.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobEngineTestSub): boolean {
        Object.setPrototypeOf(obj, BackgroundJobEngineTestSub.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.suspend_on) {
            models.RecordIdentity.fixupPrototype(this.suspend_on);
        }
    }

    suspend_on: models.RecordIdentity;

    sub_task_args: Array<string>;

}
